import { assign } from 'lodash';
import metadata from './metadata.json';

const jquerysfData = {
  title: 'Angular 2: The new horizon for jQuerySF',
  description: 'Learn all the basic angular 2 concepts with this talk and small sample'
};
export const jquerysfMeta = metadataGenerator(jquerysfData.title, jquerysfData.description);

const angularuData = {
  title: 'Make your angular app a maximum security prison',
  description: 'Learn how to add authentication to an Angular 1 and Angular 2 app very easily!'
};
export const angularuMeta = metadataGenerator(angularuData.title, angularuData.description);

export const cascadiaData = {
  title: 'Death to cookies: Long live JSON Web Tokens',
  description: 'Learn how to add authentication to a Vanilla JS SPA very easily!'
};
export const cascadiaMeta = metadataGenerator(cascadiaData.title, cascadiaData.description);

export const osconData = {
  title: 'Reactive Frontend',
  description: 'Learn what Observables, Stream and Reactive Programming are in this amazing talk'
};
export const osconMeta = metadataGenerator(osconData.title, osconData.description);

export const forwardData = {
  title: 'Reactive Frontend',
  description: 'Learn what Observables, Stream and Reactive Programming are in this amazing talk'
};
export const forwardMeta = metadataGenerator(forwardData.title, forwardData.description);

const fec15Data = {
  title: 'Rethinking backend with Webtasks',
  description: 'Learn what Webtasks are and how we can write Backend code in our FrontEnd app.'
};
export const fec15Meta = metadataGenerator(fec15Data.title, fec15Data.description);

function metadataGenerator(title, description) {
  const newMetadata = assign({}, metadata, {
    title,
    metas: { description }
  });
  return newMetadata;
}



// WEBPACK FOOTER //
// ./src/pages/events-landing/events-meta.js